import _get from "lodash/get";
import styled from 'styled-components';
import { rem } from 'polished';
import h2Styles from '../styles/h2Styles';
import typographyTheme from '../styles/typographyTheme';
var LargeH2 = styled.span.withConfig({
  displayName: "LargeH2",
  componentId: "sc-1c74j7j-0"
})(["", " display:block;font-size:", ";line-height:", ";padding:", " 0;"], h2Styles, function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, 'typography.largeHeadings.fontSize.h2', typographyTheme.typography.largeHeadings.fontSize.h2));
}, function (_ref2) {
  var theme = _ref2.theme;
  return _get(theme, 'typography.largeHeadings.lineHeight.h2', typographyTheme.typography.largeHeadings.lineHeight.h2);
}, function (_ref3) {
  var theme = _ref3.theme;
  return rem(_get(theme, 'typography.largeHeadings.paddingV.h2', typographyTheme.typography.largeHeadings.paddingV.h2));
});
export default LargeH2;